import * as angular from 'angular';

/**
 * This directive allows us to use string value in an angularized input box that expects numbers,
 * and is necessary because sometimes data with identical structures has different JS types fresh from the server,
 * e.g. Setpoint values (coolingTemp, heatingTemp) are numbers when retrieved via getRtuSchedule,
 * but strings when computed from sensor data
 * A plain Javascript implementation is provided by the official AngularJS documentation at the bottom of
 * https://docs.angularjs.org/error/ngModel/numfmt
 */

export class StringToNumberDirective implements angular.IDirective {
    public require: string = 'ngModel';

    public link(scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        ngModel.$parsers.push((val: any) => {
            /** If the value of an input box was blank, we'll want to send an empty string back to the server, never the string "null" */
            if (!angular.isDefined(val) || val === null) {
                return '';
            }

            return '' + val;
        });

        ngModel.$formatters.push((val: any) => {
            if (!val) {
                return null;
            }

            return parseFloat(val);
        });
    }

    public static Factory() {
        let directive = () => {
            return new StringToNumberDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
